import axios from "axios";
import pathResolver from "./PathResolver";

export default function ApiCall(
    apiName: string,
    methodType: string,
    payLoad: string | object,
    additionalHeaders: Record<string, string> = {}
) {
    const isGingco = apiName.includes("gingco");
    const url = pathResolver(
        apiName,
        isGingco,
        typeof payLoad === "string" ? payLoad : ""
    );
    const headers = {
        Accept: "application/json",
        "Content-type": "application/json; charset=utf-8",
    };

    return axios({
        method: methodType,
        url,
        data: typeof payLoad === "object" ? JSON.stringify(payLoad) : "{}",
        headers: { ...headers, ...additionalHeaders },
    })
        .then((response) => {
            console.log("success response");
            return response ? response.data : false;
        })
        .catch((error) => {
            console.error("Fetch Error :-S", error);
            return false;
        });
}
